export const ROLE_COLORS: Record<
  string,
  { bg: string; border: string; title: string; text: string }
> = {
  broker: {
    bg: 'blue.50',
    border: 'blue.500',
    title: 'blue.700',
    text: 'blue.600',
  },
  supervisor: {
    bg: 'purple.50',
    border: 'purple.500',
    title: 'purple.700',
    text: 'purple.600',
  },
  applicant: {
    bg: 'green.50',
    border: 'green.500',
    title: 'green.700',
    text: 'green.600',
  },
  co_applicant: {
    bg: 'purple.50',
    border: 'purple.500',
    title: 'purple.700',
    text: 'purple.600',
  },
  account_holder: {
    bg: 'orange.50',
    border: 'orange.500',
    title: 'orange.700',
    text: 'orange.600',
  },
  secondary_account_holder: {
    bg: 'teal.50',
    border: 'teal.500',
    title: 'teal.700',
    text: 'teal.600',
  },
  retiree: {
    bg: 'orange.50',
    border: 'orange.500',
    title: 'orange.700',
    text: 'orange.600',
  },
  excluded_driver: {
    bg: 'red.50',
    border: 'red.500',
    title: 'red.700',
    text: 'red.600',
  },
  additional_insured_1: {
    bg: 'green.50',
    border: 'green.500',
    title: 'green.700',
    text: 'green.600',
  },
  additional_insured_2: {
    bg: 'cyan.50',
    border: 'cyan.500',
    title: 'cyan.700',
    text: 'cyan.600',
  },
  auto_additional_insured_1: {
    bg: 'green.50',
    border: 'green.500',
    title: 'green.700',
    text: 'green.600',
  },
  auto_additional_insured_2: {
    bg: 'cyan.50',
    border: 'cyan.500',
    title: 'cyan.700',
    text: 'cyan.600',
  },
  home_additional_insured_1: {
    bg: 'pink.50',
    border: 'pink.500',
    title: 'pink.700',
    text: 'pink.600',
  },
  home_additional_insured_2: {
    bg: 'yellow.50',
    border: 'yellow.500',
    title: 'yellow.700',
    text: 'yellow.600',
  },
};

export const ROLE_LABELS: Record<string, string> = {
  broker: 'Broker',
  supervisor: 'Supervisor (Level 2+)',
  applicant: 'Applicant',
  co_applicant: 'Co-Applicant',
  account_holder: 'Account Holder',
  secondary_account_holder: 'Secondary Account Holder',
  retiree: 'Retiree',
  excluded_driver: 'Excluded Driver',
  additional_insured_1: 'Additional Insured #1',
  additional_insured_2: 'Additional Insured #2',
  auto_additional_insured_1: 'Auto Additional Insured #1',
  auto_additional_insured_2: 'Auto Additional Insured #2',
  home_additional_insured_1: 'Home Additional Insured #1',
  home_additional_insured_2: 'Home Additional Insured #2',
};
